<template>
    <div style="position:relative;display:grid;grid-template-columns: 14% 4% 14% 14% 37% 7% 10%;grid-template-rows: 60px;background: #ddd;padding-left:70px;">
        <div style="position:absolute;left:20px;top:0px">
         <v-checkbox
            v-model="selected"
            @change="onChange_selectAll"
        />
        </div>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Date
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            DOW
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Aircraft Config.
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Flight Number(s)
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Schedule / Slot
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Service Type
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Warnings
        </span>
    </div>
</template>

<script>
    import { eventBus } from '../../../../../main';
    export default {
        name: 'SelectedFlightListHeader',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selected: true
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightListHeader.vue >>> created');

        }, // eo function created()



        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightListHeader.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            onChange_selectAll: function (value) {

                const me = this;

                eventBus.$emit('selectallflightsfromheader', me.selected);
            }

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
